import React from 'react';
import NumeralPagination from 'elements/Pagination/NumeralPagination/NumeralPagination';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import ViewsPerPageFilter from 'elements/Pagination/ViewsPerPageFilter/ViewsPerPageFilter';


/* eslint-disable react/prop-types */
export const Numeral = ({ totalItems = 2, __key }) => <NumeralPagination totalItems={totalItems} key={`numeral-layout-${__key}`} />;

export const Carousel = ({ totalItems = 8, dark, autoplay, __key }) => (
  <CarouselPagination totalItems={totalItems} autoplay={autoplay} dark={dark} key={__key} />
);

export const VerticalCarousel = ({ totalItems = 8, size, __key }) => (
  <CarouselPagination vertical size={size} totalItems={totalItems} label="Page Name" key={__key} />
);

export const ViewsPerPage = ({ label = 'Show', max }) => (
  <ViewsPerPageFilter label={label} max={max} />
);

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Paginations/constants/paginationsLayouts.js